import { render, staticRenderFns } from "./Revise.vue?vue&type=template&id=4837d9ee"
import script from "./Revise.vue?vue&type=script&lang=js"
export * from "./Revise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports